/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetEuOrganizationDisplaySettingResponseData,
  GetEuOrganizationDisplaySettingResponseDataFromJSON,
  GetEuOrganizationDisplaySettingResponseDataFromJSONTyped,
  GetEuOrganizationDisplaySettingResponseDataToJSON
} from './GetEuOrganizationDisplaySettingResponseData'

/**
 *
 * @export
 * @interface GetEuOrganizationDisplaySettingResponse
 */
export interface GetEuOrganizationDisplaySettingResponse {
  /**
   *
   * @type {number}
   * @memberof GetEuOrganizationDisplaySettingResponse
   */
  status: number
  /**
   *
   * @type {GetEuOrganizationDisplaySettingResponseData}
   * @memberof GetEuOrganizationDisplaySettingResponse
   */
  data: GetEuOrganizationDisplaySettingResponseData
}

export function GetEuOrganizationDisplaySettingResponseFromJSON(json: any): GetEuOrganizationDisplaySettingResponse {
  return GetEuOrganizationDisplaySettingResponseFromJSONTyped(json, false)
}

export function GetEuOrganizationDisplaySettingResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetEuOrganizationDisplaySettingResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: GetEuOrganizationDisplaySettingResponseDataFromJSON(json['data'])
  }
}

export function GetEuOrganizationDisplaySettingResponseToJSON(
  value?: GetEuOrganizationDisplaySettingResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetEuOrganizationDisplaySettingResponseDataToJSON(value.data)
  }
}
